import { DateTime } from '@ksyos/date-time';
import type { OsasAddendumRecord } from '@common/validation/addendum';
import { getSelectedLanguage } from '../../../../../../translate';
import { FormRow } from '../../../../../elements/forms/FormRow';
import { FormSection, FormSubHeader } from '../../../../../elements/forms/formSection/FormSection';
import { FormGroupRead } from '../FormGroupRead';

interface OsasAddendumReadProps {
    addendum?: OsasAddendumRecord;
}

export function OsasAddendumRead(props: Readonly<OsasAddendumReadProps>) {
    const translate = getSelectedLanguage();
    if (!props.addendum) {
        return null;
    }

    return (
        <FormSection type="postit">
            <FormRow>
                <FormSubHeader>{translate.common.addendum}</FormSubHeader>
            </FormRow>
            <FormGroupRead
                label={DateTime.from(props.addendum.createdAt).format('DD-MM-YYYY [om] HH:mm[u]')}
                value={props.addendum.properties.message}
            />
        </FormSection>
    );
}
